import { render, staticRenderFns } from "./ResearchAchievement.vue?vue&type=template&id=e73df486&scoped=true"
import script from "./ResearchAchievement.vue?vue&type=script&lang=js"
export * from "./ResearchAchievement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73df486",
  null
  
)

export default component.exports